const CodeIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    aria-hidden='true'
    width='130'
    height='130'
    viewBox='0 0 130 130'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M69.9224 16.25L44.6875 110.428L60.3838 114.634L85.6187 20.4558L69.9224 16.25ZM95.4538 29.4531L129.925 63.9246L118.435 75.4151L117.775 74.7554L91.7249 100.806L80.2344 89.3152L106.285 63.2649L83.9633 40.9436L95.4538 29.4531ZM0 63.4168L34.4715 28.9453L45.9619 40.4358L22.0301 64.3677L45.962 88.2996L34.4715 99.7901L1.25915e-05 65.3186L0.950927 64.3677L0 63.4168Z'
      fill='#FF620F'
    />
  </svg>
);

export default CodeIcon;
